<template>
  <div class="flex grow flex-col gap-0.5">
    <div
      class="bg-surface-container rounded-t-large rounded-b-extra-small flex h-13 flex-row items-center pr-1.5 pl-4"
    >
      <h3 class="text-title-medium grow">Textfeedbacks</h3>
    </div>
    <div
      v-if="texts.length == 0"
      class="rounded-t-extra-small rounded-b-large bg-surface-container flex w-full items-center justify-center p-4"
    >
      <span class="text-body-medium text-on-surface-variant">Nichts ausgewählt</span>
    </div>
    <ul v-else class="flex flex-col gap-0.5">
      <li
        v-for="text in texts"
        :key="text.question.id"
        class="bg-surface-container-low rounded-extra-small last:rounded-b-large w-full p-4"
      >
        <h4 class="text-body-large text-on-surface-variant mb-2">
          {{ text.question.content }}
        </h4>
        <TextFeedbacksForPerspectives :perspectives="text.perspectives" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  import type { TextAnalysis } from '@/core/models/surveys-analytics'
  import TextFeedbacksForPerspectives from '@/core/components/analytics/text-feedback/TextFeedbacksForPerspectives.vue'

  interface Props {
    texts: ReadonlyArray<TextAnalysis>
  }

  defineProps<Props>()
</script>
